export const MARKETING = 'marketing';
export const SALES = 'sales';
export const SERVICE = 'service';
export const CMS = 'cms';
export const CONTENT = 'content';
export const OPERATIONS = 'operations';
export const CRM = 'crm';
export const SUITE = 'suite';
export const SMART_CRM = 'smart-crm';
export const BUNDLE = 'bundle';
export const COMMERCE = 'commerce';
export const MARKETING_PLUS = 'marketing-plus';
export const AllRoutes = [MARKETING, SALES, SERVICE, CMS, CONTENT, OPERATIONS, CRM, SUITE, SMART_CRM, BUNDLE, COMMERCE, MARKETING_PLUS];